import ToolCard from '../../../components/feature/ToolCard';
import { allTools, featuredTools } from '../../../mocks/tools';

export default function NewToolsThisWeek() {
  // Exclude any tool already shown in the Featured Tools section
  const featuredSlugs = new Set(featuredTools.map((t) => t.slug));

  const newTools = allTools
    .filter((tool) => tool.badge === 'new' && !featuredSlugs.has(tool.slug))
    // Deduplicate by slug
    .filter((tool, index, self) => self.findIndex((t) => t.slug === tool.slug) === index)
    .slice(0, 8);

  return (
    <section className="py-20 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <header className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-teal-500/10 border border-teal-500/20 text-teal-400 text-xs font-semibold tracking-widest uppercase mb-5">
            <i className="ri-sparkling-line text-xs"></i>
            Fresh Arrivals
          </span>
          <h2
            id="new-tools-heading"
            className="text-3xl md:text-4xl font-extrabold text-white mb-4 tracking-tight leading-tight"
          >
            New AI Tools This Week
          </h2>
          <p className="text-sm text-gray-500 max-w-xl mx-auto leading-relaxed">
            Discover the latest AI tools added to our directory — handpicked and reviewed by the Toolnova Editorial Team.
          </p>
        </header>

        {/* Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {newTools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </div>
    </section>
  );
}
